/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

import { jsx } from '@compiled/react';

import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

import { List } from '../../components/list';

const styles = cssMap({
	root: {
		gridColumn: 3,
		display: 'flex',
		justifyContent: 'end',
	},
	list: {
		alignItems: 'center',
		display: 'flex',
		gap: token('space.050'),
	},
});

/**
 * __User actions__
 *
 * Wrapper for the top navigation actions on the inline-end (right) side of the top navigation.
 */
export const UserActions = ({
	children,
	label = 'Actions',
}: {
	children: React.ReactNode;
	label?: string;
}) => (
	<nav aria-label={label} css={styles.root}>
		<List xcss={styles.list}>{children}</List>
	</nav>
);
